// https://dev.to/kingdaro/indexing-objects-in-typescript-1cgi
/* eslint-disable  @typescript-eslint/no-explicit-any */
/** Usage: hasKey(styles, size) ? styles[size] : '' */
export function hasKey<O>(obj: O, key: keyof any): key is keyof O {
  return key in obj;
}
